import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@navent-jobs/ui-kit/components/button'
import Text from '@navent-jobs/ui-kit/components/text'

import { IncompleteDataTitleContainer, IncompleteDataTitle, IncompleteDataText, CustomIcon } from './mixins'

const Component = ({
  postulacion: { motivoEspera = 'ACTIVACION' },
  emailApplicant,
  redirect,
  handleActivateMail,
  isLoading,
}) => {
  const { t } = useTranslation()

  /**
   * Se muestra distinto contenido en el componente dependiendo del motivo de espera de la postulación
   */
  const statusContent = {
    ACTIVACION: {
      title: t('fichaAviso.postularBar.activaTuCuenta'),
      text: `${t('fichaAviso.postulacion.incompleta.activarCuenta')} ${emailApplicant}`,
      disabled: isLoading,
      button: t('fichaAviso.postularBar.reenviarMail'),
      onClick: () => handleActivateMail(),
    },
    CV_INCOMPLETO: {
      title: t('fichaAviso.postularBar.completaTuCV', { cv: t('cv') }),
      text: t('fichaAviso.postulacion.incompleta.completarCV', { cv: t('cv') }),
      button: t('fichaAviso.postulacion.incompleta.completarMiCV', { cv: t('cv') }),
      disabled: false,
      onClick: () => redirect('/candidatos/curriculum'),
    },
  }

  return (
    <div>
      <IncompleteDataTitleContainer>
        <CustomIcon name="icon-light-alert-triangle" size="20" />
        <IncompleteDataTitle>
          <Text size="md" fontWeight="semibold" variant="danger" as="span">
            {t('fichaAviso.postulacion.incompleta.estado')}
            {statusContent[motivoEspera] && statusContent[motivoEspera].title}
          </Text>
        </IncompleteDataTitle>
      </IncompleteDataTitleContainer>

      <IncompleteDataText>
        <Text size="md">{statusContent[motivoEspera].text}</Text>
      </IncompleteDataText>

      <Button
        buttonoptions={{ variant: 'secondary', block: true }}
        onClick={statusContent[motivoEspera].onClick}
        disabled={statusContent[motivoEspera].disabled}
        isLoading={isLoading}
      >
        {statusContent[motivoEspera].button}
      </Button>
    </div>
  )
}

export default Component
